import { HttpWebtrack } from 'utility/http';
import { ConfigActions } from '../../../../utility/http/http-events';

import configureInterceptors from 'utility/http/interceptors/configure-interceptors';
import { store } from '@redux/storeConfig/store';

export const baseUrl = '/route';

export const getRouteAssignmentsListService = async (
  request: any,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getAssignments`, request);
};

export const getAssignedUnitsListService = async (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getAssignedUnits`, request);
};

export const saveAssignmentService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    name: `${request.unitName}`,
    object: 'routes.assignmentOfUnit',
    action: request.routeAssignmentId ? 'Edit' : 'Create',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/saveAssignment`, request);
};

export const deleteAssignmentService = (request: any, configActions: ConfigActions) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    name: `${request.unitName}`,
    object: 'routes.assignmentOfUnit',
    action: 'Delete',
    genderType: 'SingularFemale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/deleteAssignment`, request);
};

export type RouteAssignmentsRequest = {
  routeAssignments: string | null;
  completionType: number | null;
  alreadyLeftTheOrigin: boolean | null;
  automaticMonitoringWhenArrivingAtOrigin?: boolean | null;
  assignmentDate?: string | null;
  useUnitPrivateCode?: boolean;
  useRoutePrivateCode?: boolean;
  useCustomerPrivateCode?: boolean;
};

export const importRouteAssignmentsService = async (
  request: RouteAssignmentsRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/importAssignments`, request);
};

export type GetSchedulingConflictRequest = {
  unitId: number;
  startDate?: string | null;
  scheduleId?: number | null;
  minDiffTimeInMinutes?: number;
};

export type GetSchedulingConflictResponse = {
  hasConflict: boolean;
  conflictingRouteId?: number | null;
  conflictingRouteName?: string | null;
  conflictingStartDate?: string | null;
  conflictingScheduleId?: number | null;
  conflictingNextRunDate?: string | null;
  conflictingCompletionTime?: number | null;
};

export const getSchedulingConflictService = async (
  request: GetSchedulingConflictRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getSchedulingConflict`, request);
};

export type GetActiveAssignmentsRequest = {
  startDate?: string | null;
  endDate?: string | null;
  organizationId?: number | null;
  divisionId?: number | null;
  subdivisionId?: number | null;
  unitId?: number | null;
};

export type RouteAssignmentItem = {
  routeAssignmentId: number;
  routeId: number;
  routeName: string;
  unitId: number;
  unitName: string;
  driverId?: number | null;
  driverName?: string | null;
  assignmentDate?: string | null;
  startDate?: string | null;
  customField1?: string | null;
  customField2?: string | null;
  customField3?: string | null;
  customField4?: string | null;
  customField5?: string | null;
  customField6?: string | null;
  driverExtraPhoneNumbers?: string | null;
  vesselName?: string | null;
  shipmentTypeId?: number | null;
  hasVgmCertificate?: boolean | null;
  vgmCertificateDescription?: string | null;
  isStc?: boolean | null;
  stcDescription?: string | null;
  hasCustodian?: boolean | null;
  custodianName?: string | null;
  custodianPhoneNumber?: string | null;
  routeStatus?: number | null;
  routeStatusDescription?: string | null;
  assignmentStatus?: number | null;
  customerId?: number | null;
  customerName?: string | null;
  unitOrganizationId?: number | null;
  scheduleName?: string | null;
  scheduleId?: number | null;
  startTime?: string | null;
  nextRunDate?: string | null;
};

export type GetActiveAssignmentsResponse = {
  byDate: RouteAssignmentItem[];
  bySchedule: RouteAssignmentItem[];
};

export const getActiveAssignmentsService = async (
  request: GetActiveAssignmentsRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);

  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/getActiveAssignments`, request);
};
